import './MainContainer.css';
import Header from "../common/header/Header";
import { Navigate, Route, Routes } from 'react-router';
import routes from '../common/routes';
import PageNotFound from '../common/error/PageNotFound';

const MainContainer = () => {
    return (
            <>
            <Header/>
            <div data-testid="routes" className='main-container'>
              <Routes>
                <Route>
                  {routes.map((item, i) => (
                    <Route path={item.path} element={item.element} key={i} />
                  ))}
                  <Route path="*" element={<PageNotFound />} />
                </Route>
              </Routes>
            </div>
        </>
      );
    };

export default MainContainer;
